/**
 * Chave única do cache persistido do TanStack Query no localStorage.
 *
 * FONTE DA VERDADE: `main.tsx` (o persister) e TODOS os fluxos de fim de sessão
 * importam daqui pra nunca divergir. Bug histórico: o logout limpava a chave
 * `chatplus-query-cache` enquanto o persister salvava em `chatplus-query-cache:v2`
 * → o cache do tenant anterior nunca era apagado e vazava no login seguinte
 * (canais/listas de OUTRA instância apareciam por alguns segundos até o refetch).
 *
 * Bump o sufixo quando shapes de cache mudarem (ex: query → infiniteQuery) —
 * sem isso, cache persistido tenta hidratar shapes antigos no boot e crasha.
 */
export const PERSIST_CACHE_KEY = 'chatplus-query-cache:v2';

/**
 * Marca do último ponto sincronizado com o servidor (vide
 * `features/atendimento/reconexao.ts`). Mora aqui, junto do cache persistido,
 * porque tem exatamente o MESMO ciclo de vida: é estado desta sessão, e vazar
 * pra próxima faria o painel achar que está em dia sobre um período que nunca
 * viu — no mesmo navegador, possivelmente de outro cliente.
 *
 * Deixar a limpeza dela junto da do cache é o que torna impossível esquecer:
 * são sete os caminhos de fim de sessão (logout, logout de todos, revogação
 * pelo admin, troca de departamento, expiração do refresh…), e todos já passam
 * por `clearPersistedQueryCache`.
 */
export const SYNC_MARK_KEY = 'chatplus:sincronizado-ate';

/**
 * Limpa o cache persistido do TanStack. Chamar em TODO fim de sessão (logout,
 * logout-de-todos, revogação remota, expiração 401) ANTES do reload — senão a
 * próxima sessão (mesmo outro tenant no mesmo browser) restaura dados do tenant
 * anterior por alguns segundos (vazamento cross-tenant na UI).
 */
export function clearPersistedQueryCache(): void {
  try {
    localStorage.removeItem(PERSIST_CACHE_KEY);
    // Chave legada (pré-:v2) — remove por garantia.
    localStorage.removeItem('chatplus-query-cache');
    // Marca de sincronia: mesmo motivo do cache, vide SYNC_MARK_KEY.
    localStorage.removeItem(SYNC_MARK_KEY);
  } catch {
    // localStorage indisponível/cheio — não bloqueia o logout.
  }
}
